// Words shared by every page: actions, load states, statuses and the shared components.
export default {
  actions: {
    add: "Add",
    back: "Back",
    cancel: "Cancel",
    clear: "Clear",
    close: "Close",
    confirm: "Confirm",
    copy: "Copy",
    create: "Create",
    delete: "Delete",
    done: "Done",
    download: "Download",
    edit: "Edit",
    open: "Open",
    refresh: "Refresh",
    remove: "Remove",
    retry: "Try again",
    save: "Save",
    search: "Search",
    view: "View",
  },
  states: {
    loading: "Loading…",
    couldNotLoad: "Could not load",
    refused: "Refused",
    saving: "Saving…",
    none: "None",
    never: "Never",
    unknown: "Unknown",
    yes: "Yes",
    no: "No",
    all: "All",
  },
  e2ee: "End-to-end encrypted",
  breadcrumb: "Breadcrumb",
  today: "Today",
  yesterday: "Yesterday",
  /** A collapsed block of error or system text with a dialog to read it (ui/OutputPeek). */
  output: {
    error: "Error",
    output: "Output",
    system: "System input",
    view: "View",
    copied: "Copied",
    dialogHint: "The full text, as recorded",
  },
  /** A side card that folds to its header (ui/CollapsibleCard). */
  card: {
    collapse: (title: string) => `Collapse ${title}`,
    expand: (title: string) => `Expand ${title}`,
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    allLabel: "All cards",
  },
  language: {
    label: "Language",
    choose: "Choose a language",
  },
  /** Statuses of the platform's state machines (docs/03); the pill capitalises the first letter. */
  status: {
    queued: "queued",
    admitted: "admitted",
    starting: "starting",
    running: "running",
    waiting_for_human: "waiting for human",
    collecting: "collecting",
    succeeded: "succeeded",
    failed: "failed",
    timed_out: "timed out",
    skipped: "skipped",
    cancelled: "cancelled",
    requested: "requested",
    provisioning: "provisioning",
    configuring_network: "configuring network",
    ready: "ready",
    stopped: "stopped",
    deleting: "deleting",
    deleted: "deleted",
    active: "active",
    suspended: "suspended",
    draft: "draft",
    disabled: "disabled",
    archived: "archived",
    paused: "paused",
    answered: "answered",
    waiting: "waiting",
    finished: "finished",
    pending: "pending",
  },
};
